import React from 'react';
import cn from 'classnames';

import css from './ui-radio-icon-v2.module.scss';


type UIRadioIconV2Props = {
    checked?: boolean,
}

export function UIRadioIconV2({ checked = false }: UIRadioIconV2Props) {
    const classes = cn({
        [css.uiRadioIconV2]: true,
        [css.checked]: checked,
    });

    return (
        <div id="ui-radion-button-v2" className={classes} />
    );
}
